export default __webpack_public_path__ + "static/media/LoyaltyCross.879dafba.svg";